import { Button } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { FC, PropsWithChildren, useState } from 'react'
import { AuthFlowModal } from '../../../__legacy__/components/AuthFlow/AuthFlowModal'
import DropdownMenu from '../../../__legacy__/components/core/DropdownMenu'
import { EditProfileFlowModal } from '../../../__legacy__/components/EditProfileFlowModal/EditProfileFlowModal'
import { ProfileCardDropdownMenuContent } from '../../../__legacy__/components/platform/dashboard/ProfileCard'
import Notifications from '../../../__legacy__/components/profile/Notifications'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { Profile } from '../primitives'

const AuthButton: FC = () => (
  <AuthFlowModal trigger={<Button variant="secondaryInverted"> Log in </Button>} />
)

type ProfileDropdownProps = PropsWithChildren<{ onLogout: () => void; user: any }>
const ProfileDropdown: FC<ProfileDropdownProps> = ({ onLogout, children, user }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <DropdownMenu.Body trigger={children}>
        <ProfileCardDropdownMenuContent
          user={user}
          logout={onLogout}
          openEditProfileModal={() => setOpen(true)}
        />
      </DropdownMenu.Body>
      <EditProfileFlowModal open={open} onOpenChange={(value) => setOpen(value)} />
    </>
  )
}

export const ProfileCard: FC = observer(() => {
  const { user, logout, isUserLoading } = useAuth()
  if (isUserLoading) return <Profile.Loader />
  if (!user) return <AuthButton />
  const { profile_picture } = user
  return (
    <Profile.Root>
      <Notifications />
      <ProfileDropdown user={user} onLogout={logout}>
        <Profile.Card>
          <Profile.Avatar src={profile_picture} />
          <Profile.Caret />
        </Profile.Card>
      </ProfileDropdown>
    </Profile.Root>
  )
})
